var React = require('react');
var css = require('./module.scss');


/**
 * 使用方法：
 * <Input size="sm" wtype='2' placeholder="small" disabled={true}/>
 *
 * size: 不设置时为默认值，可设置为sm,lg, 主要改变高度
 * wtype: 宽度，不设置是为默认值，可设置为1和2，主要改变宽度和左右padding
 * 可添加disabled和readonly属性
 */

let ie = /msie (\d+\.\d+)/i.test(navigator.userAgent) ? (document.documentMode || + RegExp['\x241']) : undefined;

var Input = React.createClass({

    getInitialState: function() {
        // var value = (this.props.value !== undefined && this.props.value !== '') ? this.props.value : '';
        //
        // if (ie <= 9 && (value == undefined || value == '')) {
        //     value = this.props.placeholder || '';
        // }
        return {
            // value: value
            showTip:false,
            oldValue:'',//普通Input使用,非formItem,没有中间props传值会导致input没有刷新,用来替换校验不通过的值
        }
    },

    // componentWillReceiveProps: function(nextProps) {
    //     var value = (nextProps.value !== undefined && nextProps.value !== '') ? nextProps.value : '';

    //     if (ie <= 9 && (value == undefined || value == '')) {
    //         value = this.props.placeholder || '';
    //     }
    //     this.setState({
    //         value
    //     });
    // },
    componentDidMount: function() {
        let _this = this
        if(this.props.toolTipId){
            const element = document.querySelector(`#${this.props.toolTipId}`);
            element.addEventListener("mouseover", function(event) {
                const inputElement = _this.getTarget()
                if (inputElement.scrollWidth > inputElement.clientWidth) {
                    _this.state.showTip = true
                    _this.setState()
                }
            });
            // 添加鼠标移出事件监听器
            element.addEventListener("mouseout", function() {
                _this.state.showTip = false
                _this.setState()
            });
        }
    },
    getTarget: function () {
        return this.refs[this.props.name];
    },

    onChange: function (e) {
        var value = e.target.value;
        var dataType = this.props.dataType;
        var len = this.props.len ? this.props.len - 1 : null; // 最大几位
        if (dataType === 'money') {
            let reg = new RegExp("((^[1-9]\\d{0," + len + "})|^0)(\\.\\d{0,2}){0,1}$", "g");
            if (value !== '' && !('' + value).match(/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/g)) {
                e.target.value = this.state.oldValue
                return;
            } else if (len && value !== '' && !reg.test('' + value)) {
                e.target.value = this.state.oldValue
                return;
            }
        }else if (dataType === 'money1') {
            let reg = new RegExp("((^[1-9]\\d{0," + len + "})|^0)(\\.\\d{0,1}){0,1}$", "g");
            if (value !== '' && !('' + value).match(/((^[1-9]\d*)|^0)(\.\d{0,1}){0,1}$/g)) {
                e.target.value = this.state.oldValue
                return;
            } else if (len && value !== '' && !reg.test('' + value)) {
                e.target.value = this.state.oldValue
                return;
            }
        }else if (dataType === 'money2') {
            let reg = new RegExp("((^[1-9]\\d{0," + len + "})|^0)(\\.\\d{0,4}){0,1}$", "g");
            if (value !== '' && !('' + value).match(/((^[1-9]\d*)|^0)(\.\d{0,4}){0,1}$/g)) {
                e.target.value = this.state.oldValue
                return;
            } else if (len && value !== '' && !reg.test('' + value)) {
                e.target.value = this.state.oldValue
                return;
            }
        }else if (dataType === 'amount') {
            if (value !== '' && !('' + value).match(/^([1-9]\d*)?$/g)) {
                e.target.value = this.state.oldValue
                return;
            }
        } else if (dataType === 'amount1') {//只能输入[0,90]之间的整数
            if (value !== '' && !('' + value).match(/^(?:[0-9]|[1-8][0-9]|90)$/)) {
                e.target.value = this.state.oldValue
                return;
            }
        }else if (dataType === 'discount') {
            if (value !== '' && !('' + value).match(/^(0\.\d+|[1-9][0-9]|1)$/g)) {
                e.target.value = this.state.oldValue
                return;
            }
        } else if (dataType === 'hour') {
            if (value !== '' && !('' + value).match(/((^[1-9]\d*)|^0)(\.\d{0,1}){0,1}$/g)) {
                e.target.value = this.state.oldValue
                return;
            }
        }else if (dataType === 'no') {//职能输入 数字和 英文
            if (value !== '' && !('' + value).match(/^[0-9a-zA-Z]*$/g)) {
                e.target.value = this.state.oldValue
                return;
            }
        }else if(dataType === 'telephone') {//11位移动电话
            if (value !== '' && !('' + value).match(/^([0-9]\d{0,10})?$/g)) {
                e.target.value = this.state.oldValue
                return;
            }
        }
        this.state.oldValue = e.target.value
        this.props.onChange && this.props.onChange(e);
    },


    onClick: function (e) {
        // var value = this.state.value;
        // if (ie <= 9 && (value == this.props.placeholder)) {
        //     this.setState({
        //         value: ''
        //     });
        // }
        this.props.onClick && this.props.onClick(e);
    },

    onBlur: function (e) {
        // var value = this.state.value;
        // if (ie <= 9 && (value == '')) {
        //     this.setState({
        //         value: this.props.placeholder
        //     });
        // }
        this.props.onBlur && this.props.onBlur(e);
    },

    render: function () {
        let _this = this
        var cls = [
            this.props.className, 'fp-form-input'
        ];

        if (this.props.size) {
            cls.push('fp-input-' + this.props.size);
        }

        if (this.props.wtype) {
            cls.push('fp-wtype-' + this.props.wtype);
        }
        if(this.props.toolTipId)
        return (
            <div id={this.props.toolTipId} className={this.state.showTip?"tooltip-container":''} data-tooltip={this.state.showTip?this.props.title:''}>
                <input
                    className={cls.join(' ')}
                    style={this.props.style}
                    type={this.props.type || 'text'}
                    ref={this.props.name}
                    id={this.props.name}
                    name={this.props.name}
                    disabled={this.props.disabled}
                    readOnly={this.props.readonly}
                    onFocus={this.props.onFocus}
                    onBlur={this.onBlur}
                    onKeyDown={this.props.onKeyDown}
                    onKeyPress={this.props.onKeyPress}
                    onInput={this.props.onInput}
                    onKeyUp={this.props.onKeyUp}
                    onChange={this.onChange}
                    onClick={this.onClick}
                    placeholder={this.props.placeholder}
                    defaultValue={ie <= 9 ? this.props.placeholder : ''}
                    autoComplete={this.props.autoComplete || 'off'}
                    value={this.props.value}
                    dataType={this.props.dataType}
                    maxLength={this.props.maxLength}
                />
            </div>
        );
        else
            return (
                    <input
                        className={cls.join(' ')}
                        style={this.props.style}
                        type={this.props.type || 'text'}
                        ref={this.props.name}
                        id={this.props.name}
                        name={this.props.name}
                        disabled={this.props.disabled}
                        readOnly={this.props.readonly}
                        onFocus={this.props.onFocus}
                        onBlur={this.onBlur}
                        onKeyDown={this.props.onKeyDown}
                        onKeyPress={this.props.onKeyPress}
                        onInput={this.props.onInput}
                        onKeyUp={this.props.onKeyUp}
                        onChange={this.onChange}
                        onClick={this.onClick}
                        placeholder={this.props.placeholder}
                        defaultValue={ie <= 9 ? this.props.placeholder : ''}
                        autoComplete={this.props.autoComplete || 'off'}
                        value={this.props.value}
                        dataType={this.props.dataType}
                        maxLength={this.props.maxLength}
                    />
            );
    }

});

module.exports = Input;



// WEBPACK FOOTER //
// ./component/input/index.js